import * as angular from "angular";
import {IController} from "angular";
import {LocationType} from "../../../commons/types/location.type";

export class ServicesLocationBulkEditComponent implements IController {

  payload: any;
  sections: any;
  onSectionsChange: Function;
  onPayloadChange: Function;

  public locationTypes: typeof LocationType = LocationType;

  constructor() {
  }

  $onInit() {
  }

  onToggleSection(section) {
    this.sections[section] = !this.sections[section];
    this.onSectionsChange({sections: this.sections})
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('servicesLocationBulkEdit', {
    bindings: {
      sections: '<',
      payload: '<',
      onSectionsChange: '&',
      onPayloadChange: '&'
    },
    template: require('./services-location-bulk-edit.html').default,
    controller: ServicesLocationBulkEditComponent
  });
